import Spinner from 'react-bootstrap/Spinner'
const CenteredLoader = props =>(
	<div style={{
		width:'100%',
		height:'100%',
		display:'flex',
		alignItems:'center',
		justifyContent:'center'
	}}>
		<div className="d-flex align-items-center flex-column">
			<div>{props.children}</div>
			<Spinner animation="border" role="status" variant="primary">
				<span className="sr-only">Loading...</span>
			</Spinner>
		</div>
	</div>
)

export default CenteredLoader